// Portfolio weddings. Photography is the studio's own work
// (public/images/portfolio/); captions are written in-house and are
// not intended to name the real couples pictured.
const weddings = [
  {
    slug: "amara-rohan-kumarakom",
    title: "Amara & Rohan",
    location: "Kumarakom, Kerala",
    eventType: "Lakeside Wedding",
    year: "2025",
    cover: "/images/portfolio/amara-rohan-cover.webp",
    gallery: [
      "/images/portfolio/amara-rohan-1.webp",
      "/images/portfolio/amara-rohan-2.webp",
      "/images/portfolio/amara-rohan-3.webp",
    ],
    story:
      "A three-day celebration built around a grand gold mandap, with every surface designed as one continuous piece of architecture.",
    fullStory:
      "The brief called for scale without losing warmth. We built a floor-to-ceiling gold mandap framed in hand-carved pillars, with a wall of blush and ivory blooms cascading from the canopy. Traditional brass lamps and fruit offerings anchored the ceremony space, while the reception moved into a matching palette of gold and antique rose.",
  },
  {
    slug: "meera-arjun-kochi",
    title: "Meera & Arjun",
    location: "Kochi, Kerala",
    eventType: "Convention Centre Wedding",
    year: "2024",
    cover: "/images/portfolio/meera-arjun-cover.webp",
    gallery: [
      "/images/portfolio/meera-arjun-1.webp",
      "/images/portfolio/meera-arjun-2.webp",
      "/images/portfolio/meera-arjun-3.webp",
    ],
    story:
      "A convention-hall mandap transformed with a wall of fresh roses, hanging florals and a hand-carved golden Ganesh centrepiece.",
    fullStory:
      "Meera wanted the hall to feel unrecognisable from its usual self. We built a floral proscenium of pink and ivory roses framing a carved gold Ganesh backdrop, with hanging strands of jasmine and bougainvillea threaded through brass bells. Every pillar was dressed floor to ceiling, so nothing of the original room showed through.",
  },
  {
    slug: "isha-vikram-kovalam",
    title: "Isha & Vikram",
    location: "Kovalam, Kerala",
    eventType: "Poolside Reception",
    year: "2024",
    cover: "/images/portfolio/isha-vikram-cover.webp",
    gallery: [
      "/images/portfolio/isha-vikram-1.webp",
      "/images/portfolio/isha-vikram-2.webp",
      "/images/portfolio/isha-vikram-3.webp",
    ],
    story:
      "A clear-roof marquee over the pool, dressed in blush drapery and suspended florals reflected in the water below.",
    fullStory:
      "For a poolside reception, we built a fully clear-roofed marquee so the evening sky stayed part of the room, hung with crystal chandeliers and blush drapery down every column. Floating lanterns on the water picked up the reflection of the stage, and the aisle ran directly alongside the pool's edge for the ceremony.",
  },
  {
    slug: "diya-kabir-guruvayur",
    title: "Diya & Kabir",
    location: "Guruvayur, Kerala",
    eventType: "Temple-Style Ceremony",
    year: "2023",
    cover: "/images/portfolio/diya-kabir-cover.webp",
    gallery: [
      "/images/portfolio/diya-kabir-1.webp",
      "/images/portfolio/diya-kabir-2.webp",
      "/images/portfolio/diya-kabir-3.webp",
    ],
    story:
      "A temple-inspired stage in carved gold, with deity idols framed by a living green wall and traditional brass lamps.",
    fullStory:
      "Diya wanted the ceremony to feel rooted in ritual. We designed a carved gold temple facade as the backdrop, set against a living green wall, with rows of traditional brass oil lamps lining the approach. Banana leaf place settings and fresh fruit offerings completed the ceremony space in the old style, done properly.",
  },
  {
    slug: "priya-siddharth-alleppey",
    title: "Priya & Siddharth",
    location: "Alleppey, Kerala",
    eventType: "Backwater Mehendi",
    year: "2023",
    cover: "/images/portfolio/priya-siddharth-cover.webp",
    gallery: [
      "/images/portfolio/priya-siddharth-1.webp",
      "/images/portfolio/priya-siddharth-2.webp",
      "/images/portfolio/priya-siddharth-3.webp",
    ],
    story:
      "A backwater-side pandal in fuchsia and marigold silk, with a hand-strung floral canopy over the mehendi seating.",
    fullStory:
      "Set on the edge of the backwaters, this pandal used bold pink and marigold drapery against the tiled roof of a traditional Kerala pavilion. We strung marigold garlands across the entrance and built a low stage for the mehendi seating, so the couple stayed at the centre of the celebration rather than raised above it.",
  },
  {
    slug: "ananya-dev-thiruvananthapuram",
    title: "Ananya & Dev",
    location: "Thiruvananthapuram, Kerala",
    eventType: "Contemporary Reception",
    year: "2022",
    cover: "/images/portfolio/ananya-dev-cover.webp",
    gallery: [
      "/images/portfolio/ananya-dev-1.webp",
      "/images/portfolio/ananya-dev-2.webp",
      "/images/portfolio/ananya-dev-3.webp",
    ],
    story:
      "A modern reception under a cluster of geometric brass lanterns, with a restrained cream-and-gold stage.",
    fullStory:
      "With a contemporary couple who wanted restraint over spectacle, we kept the stage to a single cream sofa and layered floral panels, and let a cluster of geometric brass-framed lanterns do the visual work overhead. The aisle ran through arched floral frames rather than a single mandap, giving the room a gallery-like rhythm.",
  },
];

export default weddings;
